
// import { Route, RouteObject } from "react-router-dom";
// import DashboardPage from "./DashboardPage";



// export interface wxWxDashboardRoutes extends Omit<RouteObject, "children"> {
//   auth?: boolean;
//   children?: wxWxDashboardRoutes[];
// }
// export const wxWxDashboardRoutes: wxWxDashboardRoutes[] = [
//   {
//     path: "/service-orders/wx-dashboard",
//     element: <DashboardPage />,
//   },
// ];

import { Route, RouteObject } from 'react-router-dom';
import DashboardPage from './DashboardPage';
import ServiceOrderDashboard from './DashboardPage';
import Index from './DashboardPage';



export interface wxWxDashboardRoutes extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: wxWxDashboardRoutes[];
}

export const mxDashboardRoutes: wxWxDashboardRoutes[] = [
  {
      path: 'wx/dashboard',
      element: <Index />,
    },
];
